import { useAuthContext } from '@color/lib';
import { useLocation } from 'react-router-dom';

// TODO: Add deps - if currentUser is stable, then this is stable
export function useParamUser() {
  const { currentUser } = useAuthContext();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const paramUserId = params.get('participant') || params.get('pt');

  if (!paramUserId || !currentUser) {
    return undefined;
  }
  const users = [currentUser, ...currentUser.dependents];
  const user = users.find((u) => `${u.id}` === paramUserId || `${u.patient_id}` === paramUserId);
  if (user) {
    return user;
  }

  throw new Error(`Invalid participant query param ${paramUserId}`);
}
